import { c as _c } from "react/compiler-runtime";
import type { ReactNode, JSX } from 'react';
import { NotificationList } from './components/notification-list';
import { NotificationContextProvider } from './context';
interface Props {
  children: ReactNode;
  offsetX?: number;
}
export function NotificationProvider(props) {
  const $ = _c(4);
  const {
    children,
    offsetX
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NotificationList />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children || $[2] !== offsetX) {
    t1 = <NotificationContextProvider offsetX={offsetX}>{children}{t0}</NotificationContextProvider>;
    $[1] = children;
    $[2] = offsetX;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}